import GenericDB from './generic-db';

export default class NativeAppVersionsDB extends GenericDB {
  constructor() {
    super('nativeAppVersions');
  }

  // Here you can extend NativeAppVersionsDB with custom methods
}
